import { render, staticRenderFns } from "./SampleEditForm.vue?vue&type=template&id=b0e1a0fa&"
import script from "./SampleEditForm.vue?vue&type=script&lang=js&"
export * from "./SampleEditForm.vue?vue&type=script&lang=js&"
import style0 from "./SampleEditForm.vue?vue&type=style&index=0&id=b0e1a0fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports